import { getEffectiveDate } from '@/lib/api';

const PERFECT_TODAY_KEY = 'locomoco_perfect_today';

interface PerfectTodayCache {
  date: string;
  wordIds: string[];
}

/** 今日の「もう完璧」単語IDを取得 */
export function getPerfectToday(dayStartHour = 0): string[] {
  if (typeof window === 'undefined') return [];
  const stored = localStorage.getItem(PERFECT_TODAY_KEY);
  if (!stored) return [];

  try {
    const data = JSON.parse(stored) as PerfectTodayCache;
    const effectiveDate = getEffectiveDate(dayStartHour);
    if (data.date !== effectiveDate) {
      localStorage.removeItem(PERFECT_TODAY_KEY);
      return [];
    }
    return data.wordIds;
  } catch {
    return [];
  }
}

export function addPerfectToday(wordId: string, dayStartHour = 0) {
  if (typeof window === 'undefined') return;
  const current = getPerfectToday(dayStartHour);
  const effectiveDate = getEffectiveDate(dayStartHour);
  localStorage.setItem(
    PERFECT_TODAY_KEY,
    JSON.stringify({ date: effectiveDate, wordIds: [...new Set([...current, wordId])] }),
  );
}

/** 今日の完璧キャッシュをクリア（もう一周モード開始時など） */
export function clearPerfectToday() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(PERFECT_TODAY_KEY);
}
